import { createAction } from 'redux-actions'

const ns = 'dashboard/'

export const getSpecificCompanyDashboard = createAction(`${ns}GET_COMPANY_DASHBOARD`)
export const getSpecificCompanyDashboardSuccess = createAction(`${ns}GET_COMPANY_DASHBOARD_SUCCESS`)

export const getCompanyEmployees = createAction(`${ns}GET_COMPANY_EMPLOYEES`)
export const getCompanyEmployeesSuccess = createAction(`${ns}GET_COMPANY_EMPLOYEES_SUCCESS`)

export const setCompanyEmployees = createAction(`${ns}SET_COMPANY_EMPLOYEES`)
export const setCompanyEmployeesSuccess = createAction(`${ns}SET_COMPANY_EMPLOYEES_SUCCESS`)
